var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-account-group-outline",
      show: _vm.dialog,
      maxWidth: "60%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-tabs",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", { key: "main", attrs: { "tab-value": "main" } }, [
                  _vm._v("Dados"),
                ]),
                _c("v-tab", { key: "offer", attrs: { "tab-value": "offer" } }, [
                  _vm._v("Oferta"),
                ]),
                _vm.model && _vm.model.id
                  ? _c(
                      "v-tab",
                      { key: "trail", attrs: { "tab-value": "trail" } },
                      [_vm._v("Trilha")]
                    )
                  : _vm._e(),
                _c(
                  "v-tab",
                  { key: "others", attrs: { "tab-value": "others" } },
                  [_vm._v("Demais Dados")]
                ),
                _c(
                  "v-tab",
                  { key: "students", attrs: { "tab-value": "students" } },
                  [_vm._v("Alunos")]
                ),
                _vm.model && _vm.model.id
                  ? _c(
                      "v-tab",
                      {
                        key: "availability",
                        attrs: { "tab-value": "availability" },
                      },
                      [_vm._v("Disponibilidade")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  { key: "main", attrs: { value: "main" } },
                  [
                    _c(
                      "v-card",
                      { attrs: { flat: "" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("SelectCourse", {
                                      attrs: {
                                        item: _vm.model.course,
                                        disabled: _vm.disableCourse,
                                        "error-messages": _vm.errors.course_id,
                                      },
                                      on: {
                                        "update:item": function ($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "course",
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.model.course_id,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "course_id", $$v)
                                        },
                                        expression: "model.course_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("FormsTextField", {
                                      attrs: {
                                        "error-messages": _vm.errors.name,
                                        label: "Nome*",
                                      },
                                      model: {
                                        value: _vm.model.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "name", $$v)
                                        },
                                        expression: "model.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("SelectShift", {
                                      attrs: {
                                        item: _vm.model.shift,
                                        "error-messages": _vm.errors.shift_id,
                                        "load-data": "",
                                      },
                                      on: {
                                        "update:item": function ($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "shift",
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.model.shift_id,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "shift_id", $$v)
                                        },
                                        expression: "model.shift_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("SelectStatusGroup", {
                                      attrs: {
                                        item: _vm.model.status,
                                        "error-messages":
                                          _vm.errors.status_group_id,
                                        "load-data": "",
                                      },
                                      on: {
                                        "update:item": function ($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "status",
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.model.status_group_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "status_group_id",
                                            $$v
                                          )
                                        },
                                        expression: "model.status_group_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("SelectCampus", {
                                      attrs: {
                                        item: _vm.model.campus,
                                        "error-messages": _vm.errors.campus_id,
                                      },
                                      on: {
                                        "update:item": function ($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "campus",
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.model.campus_id,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "campus_id", $$v)
                                        },
                                        expression: "model.campus_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("SelectCategoryGroup", {
                                      attrs: {
                                        item: _vm.model.category,
                                        "error-messages":
                                          _vm.errors.category_group_id,
                                        clearable: "",
                                        "show-add": "",
                                        "load-data": "",
                                      },
                                      on: {
                                        "update:item": function ($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "category",
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.model.category_group_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "category_group_id",
                                            $$v
                                          )
                                        },
                                        expression: "model.category_group_id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("FormsTextField", {
                                      attrs: {
                                        "error-messages": _vm.errors.group,
                                        label: "Turma",
                                      },
                                      model: {
                                        value: _vm.model.group,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "group", $$v)
                                        },
                                        expression: "model.group",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("FormsTextField", {
                                      attrs: {
                                        "error-messages":
                                          _vm.errors.time_course,
                                        label: "Período",
                                      },
                                      model: {
                                        value: _vm.model.time_course,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "time_course",
                                            $$v
                                          )
                                        },
                                        expression: "model.time_course",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("FormsTextField", {
                                      attrs: {
                                        "error-messages": _vm.errors.code,
                                        label: "Código",
                                        code: "",
                                      },
                                      model: {
                                        value: _vm.model.code,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "code", $$v)
                                        },
                                        expression: "model.code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("FormsTextField", {
                                      attrs: {
                                        "error-messages":
                                          _vm.errors.code_control,
                                        label: "Código Controle",
                                        code: "",
                                      },
                                      model: {
                                        value: _vm.model.code_control,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "code_control",
                                            $$v
                                          )
                                        },
                                        expression: "model.code_control",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  { key: "offer", attrs: { value: "offer" } },
                  [
                    _c(
                      "v-container",
                      [
                        _vm.showOffer
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "12" } },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                attrs: { cols: "12", sm: "12" },
                                              },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    staticClass: "pa-3",
                                                    attrs: { outlined: "" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-overline mb-2 grey--text text--darken-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Matriz Curricular da Turma"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "sys-select-curriculum",
                                                      {
                                                        attrs: {
                                                          model:
                                                            _vm.model
                                                              .curriculum_id,
                                                          error:
                                                            _vm.errors.length >
                                                            0,
                                                          errors:
                                                            _vm.errors
                                                              .curriculum_id,
                                                          label:
                                                            "Matriz Curricular",
                                                          courseId:
                                                            _vm.model.course_id,
                                                          clearable: "",
                                                          modelObject:
                                                            _vm.selectedCurriculum,
                                                          autoComplete: "",
                                                          dense: "",
                                                          hint: "Define o universo de disciplinas e pré-requisitos. Pode ficar em branco para oferta livre.",
                                                          "persistent-hint": "",
                                                        },
                                                        on: {
                                                          "update:model":
                                                            function ($event) {
                                                              return _vm.$set(
                                                                _vm.model,
                                                                "curriculum_id",
                                                                $event
                                                              )
                                                            },
                                                          "update:modelObject":
                                                            function ($event) {
                                                              _vm.selectedCurriculum =
                                                                $event
                                                            },
                                                          "update:model-object":
                                                            function ($event) {
                                                              _vm.selectedCurriculum =
                                                                $event
                                                            },
                                                          clearSelected:
                                                            function ($event) {
                                                              _vm.selectedCurriculum =
                                                                {}
                                                            },
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                attrs: { cols: "12", sm: "12" },
                                              },
                                              [
                                                _c("OfferIntentsPlanning", {
                                                  ref: "offerIntentsPlanning",
                                                  attrs: {
                                                    "group-id":
                                                      _vm.model && _vm.model.id,
                                                    "group-work-time-id":
                                                      (_vm.model &&
                                                        _vm.model
                                                          .work_time_id) ||
                                                      _vm.workTime.id,
                                                    modules:
                                                      (_vm.selectedCurriculum &&
                                                        _vm.selectedCurriculum
                                                          .sequencies) ||
                                                      [],
                                                    "current-sequency-id":
                                                      _vm.model &&
                                                      _vm.model
                                                        .curriculum_sequency_item_id,
                                                    "offer-errors":
                                                      _vm.offerIntentErrors,
                                                  },
                                                  on: {
                                                    "update:currentSequencyId":
                                                      _vm.onPlanningSequencyChange,
                                                    "update:draftIntents":
                                                      _vm.onDraftIntentsChange,
                                                    "bulk-generate":
                                                      _vm.bulkGenerateFromIntents,
                                                  },
                                                }),
                                                _c("emc-alert-snackbar", {
                                                  attrs: {
                                                    show: !!_vm.bulkMessage
                                                      .length,
                                                    message: _vm.bulkMessage,
                                                    color: _vm.bulkMessageColor,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.model && _vm.model.id
                  ? _c(
                      "v-tab-item",
                      { key: "trail", attrs: { value: "trail" } },
                      [
                        _c(
                          "v-container",
                          [
                            _c("GroupTrail", {
                              attrs: {
                                "group-id": _vm.model.id,
                                "course-id": _vm.model.course_id,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-tab-item",
                  { key: "others", attrs: { value: "others" } },
                  [
                    _c(
                      "v-container",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectBaseGroup", {
                                  attrs: {
                                    item: _vm.model.baseGroups,
                                    "error-messages": _vm.errors.base_group_id,
                                    label: "Ingressantes",
                                    multiple: "",
                                    "return-object": "",
                                    clearable: "",
                                    filters: _vm.baseGroupFilters,
                                  },
                                  model: {
                                    value: _vm.model.baseGroups,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "baseGroups", $$v)
                                    },
                                    expression: "model.baseGroups",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("FormsTextField", {
                                  attrs: {
                                    "error-messages":
                                      _vm.errors.code_curriculum,
                                    label: "Matriz Aplicada",
                                  },
                                  model: {
                                    value: _vm.model.code_curriculum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "code_curriculum",
                                        $$v
                                      )
                                    },
                                    expression: "model.code_curriculum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectResource", {
                                  attrs: {
                                    item: _vm.model.resources,
                                    errors: _vm.errors.resources,
                                    label: "Recursos Necessários",
                                    multiple: "",
                                    "return-object": "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "resources",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.resources,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "resources", $$v)
                                    },
                                    expression: "model.resources",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectHourGroup", {
                                  attrs: {
                                    errors: _vm.errors.hour_group_id,
                                    item: _vm.model.hourGroup,
                                    clearable: "",
                                    "load-data": "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "hourGroup",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.hour_group_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "hour_group_id", $$v)
                                    },
                                    expression: "model.hour_group_id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectShift", {
                                  attrs: {
                                    item: _vm.model.timeShift,
                                    errors: _vm.errors.time_shift_id,
                                    label: "Turno do Horário",
                                    clearable: "",
                                    "load-data": "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "timeShift",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.time_shift_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "time_shift_id", $$v)
                                    },
                                    expression: "model.time_shift_id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("FormsTextField", {
                                  attrs: {
                                    "text-helper":
                                      "Número de semanas letivas. Utilizado para converter a carga horária total para semanal. Se não informado, utiliza o valor padrão cadastrado no Período Letivo",
                                    "error-messages": _vm.errors.weeks,
                                    label: "Número de Semanas",
                                  },
                                  model: {
                                    value: _vm.model.weeks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "weeks", $$v)
                                    },
                                    expression: "model.weeks",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectBranch", {
                                  attrs: {
                                    item: _vm.model.branch,
                                    errors: _vm.errors.branch_id,
                                    filters: _vm.branchFilters,
                                    clearable: "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "branch",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.branch_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "branch_id", $$v)
                                    },
                                    expression: "model.branch_id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectIdentifier", {
                                  attrs: {
                                    errors: _vm.errors.group_identifier_id,
                                    item: _vm.model.identifier,
                                    clearable: "",
                                    "show-add": "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "identifier",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.group_identifier_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "group_identifier_id",
                                        $$v
                                      )
                                    },
                                    expression: "model.group_identifier_id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectAmbienceCategory", {
                                  attrs: {
                                    errors: _vm.errors.category_ambience_id,
                                    item: _vm.model.categoryAmbience,
                                    "show-add": "",
                                    clearable: "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "categoryAmbience",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.category_ambience_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "category_ambience_id",
                                        $$v
                                      )
                                    },
                                    expression: "model.category_ambience_id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectAmbience", {
                                  attrs: {
                                    errors: _vm.errors.ambience_id,
                                    item: _vm.model.ambience,
                                    clearable: "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "ambience",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.ambience_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "ambience_id", $$v)
                                    },
                                    expression: "model.ambience_id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("SelectWorkTimeDate", {
                                  attrs: {
                                    item: _vm.model.workTimeDate,
                                    errors: _vm.errors.work_time_date_id,
                                    "load-data": "",
                                    clearable: "",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "workTimeDate",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.work_time_date_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "work_time_date_id",
                                        $$v
                                      )
                                    },
                                    expression: "model.work_time_date_id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("SelectCampus", {
                                  attrs: {
                                    errors: _vm.errors.campus_id_alternative,
                                    item: _vm.model.campusAlternative,
                                    label: "Campus Alternativo",
                                  },
                                  on: {
                                    "update:item": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "campusAlternative",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.model.campus_id_alternative,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "campus_id_alternative",
                                        $$v
                                      )
                                    },
                                    expression: "model.campus_id_alternative",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("sys-select-integration-shift", {
                                  attrs: {
                                    model: _vm.model.integration_shift_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.integration_shift_id,
                                    label: "Turno - Integração",
                                    clearable: "",
                                    shiftId: _vm.model.shift_id,
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "integration_shift_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-switch", {
                                  attrs: {
                                    "text-helper":
                                      "Bloquear atribuição de professor",
                                    inset: "",
                                    label: "Bloquear Atribuição",
                                  },
                                  model: {
                                    value: _vm.model.lock_attribution,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "lock_attribution",
                                        $$v
                                      )
                                    },
                                    expression: "model.lock_attribution",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-switch", {
                                  attrs: { inset: "", label: "Calouro" },
                                  model: {
                                    value: _vm.model.freshmen_group,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "freshmen_group", $$v)
                                    },
                                    expression: "model.freshmen_group",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  { key: "students", attrs: { value: "students" } },
                  [
                    _c(
                      "v-container",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    dense: "",
                                    "error-messages": _vm.errors.students,
                                    label: "Alunos",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.model.students,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "students", $$v)
                                    },
                                    expression: "model.students",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    dense: "",
                                    "error-messages":
                                      _vm.errors.students_forecast,
                                    label: "Alunos Previsão",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.model.students_forecast,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "students_forecast",
                                        $$v
                                      )
                                    },
                                    expression: "model.students_forecast",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    dense: "",
                                    "error-messages": _vm.errors.students_max,
                                    label: "Vagas",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.model.students_max,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "students_max", $$v)
                                    },
                                    expression: "model.students_max",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    dense: "",
                                    "error-messages":
                                      _vm.errors.students_freshmen,
                                    label: "Calouros",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.model.students_freshmen,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "students_freshmen",
                                        $$v
                                      )
                                    },
                                    expression: "model.students_freshmen",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    dense: "",
                                    "error-messages": _vm.errors.students_free,
                                    label: "Bolsistas",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.model.students_free,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "students_free", $$v)
                                    },
                                    expression: "model.students_free",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.model && _vm.model.id
                  ? _c(
                      "v-tab-item",
                      { key: "availability", attrs: { value: "availability" } },
                      [
                        _c("sys-availability-register", {
                          attrs: { model: _vm.model },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.errors.generate
              ? _c("v-alert", { attrs: { type: "error" } }, [
                  _c(
                    "ul",
                    _vm._l(_vm.errors.generate, function (error, i) {
                      return _c("li", { key: i }, [
                        _vm._v(" " + _vm._s(error) + " "),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
            _c("sys-find-discipline", {
              attrs: {
                showAdd: "",
                showSelect: "",
                singleSelect: false,
                show: _vm.dialogAddDiscipline,
              },
              on: {
                onSelect: function ($event) {
                  return _vm.selectDiscipline($event)
                },
                "update:show": function ($event) {
                  _vm.dialogAddDiscipline = $event
                },
              },
            }),
            _c("emc-alert-modal", {
              attrs: {
                disabled: _vm.loadingOffer,
                text: "Confirma a geração da oferta a partir do planejamento?",
                show: _vm.showGenerateOffer,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showGenerateOffer = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.loadingOffer,
                            loading: _vm.loadingOffer,
                            color: "orange lighten-2",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.pendingGenerationGroup
                                ? _vm.generateOfferFromIntents()
                                : _vm.generateOffer()
                            },
                          },
                        },
                        [
                          _vm._v(" Gerar Oferta"),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("mdi-flash"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("emc-alert-modal", {
              attrs: {
                text: "Deseja excluir a disciplina?",
                show: _vm.showDeleteDiscipline,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showDeleteDiscipline = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.deleteItem()
                            },
                          },
                        },
                        [
                          _vm._v("Excluir "),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("mdi-delete"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }